<div class="container history d-block">
    <div class="row history-body">
        <div class="col-sm-8 py-2 px-4">
            <h5>{{ prefixTicketCode }}</h5>
        </div>
        <!-- Start Stepper Section  -->
        <div class="stepper d-flex flex-column ml-2">
            <div class="d-flex mb-1" *ngFor="let item of historyData">
                <ng-container *ngIf="!['Updated', 'Shared', 'Unshared'].includes(item?.actionDescription)">
                    <div class="d-flex flex-column px-2 pt-3 align-items-center">
                        <div
                            class="rounded-circle text-white mb-1"
                            appHistoryClass
                            [historySectionData]="{ totalDaysTaken: item.differenceFromStart, globalSla: globalSlaCount, isCard: false }"
                        >
                            {{ item?.dayDifference }}
                        </div>
                        <div class="line h-100"></div>
                        <div class="days" [ngClass]="lang === 'en' ? 'days-en' : 'days-ar'">{{ 'days' | translate }}</div>
                    </div>

                    <!-- Start Sender Section -->
                    <div
                        class="mb-3 row pt-3"
                        appHistoryClass
                        [historySectionData]="{ totalDaysTaken: item.differenceFromStart, globalSla: globalSlaCount, isCard: true }"
                    >
                        <div [ngClass]="{ 'text-md-end': lang === 'en', 'text-md-start': lang !== 'en', 'text-center': true }" class="action-date">
                            {{ item.statusChangedAt | dateFormat : 'd MMM YYYY - HH:mm:ss' | async }}
                            <!-- {{ item.statusChangedAt | date : 'medium' }} -->
                        </div>
                        <div class="col-md-1">
                            <img [src]="item?.oldOwner?.image" onerror="this.src='assets/images/user2.jpg'" alt="User image" class="image-cover" />
                        </div>
                        <div class="col-md-11">
                            <div class="d-flex flex-column flex-sm-row w-100 align-items-center">
                                <div class="old-owner">
                                    <div class="my-2 medium">{{ item?.oldOwner?.name }}</div>
                                    <p class="text-primary align-text-start mb-0">{{ item?.oldOwner?.email }}</p>
                                </div>
                                <div class="action mt-2 mt-sm-0" *ngIf="['REASSIGN', 'DELEGATE', 'REVOKE'].includes(item?.actionDescription)">
                                    <div *ngIf="['REASSIGN', 'DELEGATE'].includes(item?.actionDescription)" class="statuSub mx-2 status-reassign medium text-capitalize">
                                        {{ 'reassign' | translate }}
                                    </div>
                                    <div *ngIf="['REVOKE'].includes(item?.actionDescription)" class="statuSub mx-2 status-reassign medium text-capitalize">
                                        {{ 'revoke' | translate }}
                                    </div>
                                </div>
                                <div class="new-owner" *ngIf="['REASSIGN', 'DELEGATE', 'REVOKE'].includes(item?.actionDescription)">
                                    <div class="my-2 medium">{{ item?.newOwner?.name }}</div>
                                    <p class="text-primary align-text-start mb-0">{{ item?.newOwner?.email }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="delegate-info align-text-start col-sm-11 offset-sm-1 handle-rtl-offset" *ngIf="item?.delegateUser">
                            <span class="medium">{{ 'assigner' | translate }}:</span> {{ item?.delegateUser?.name+' '+item?.delegateUser?.email }}
                        </div>
                        <div class="col-sm-8 offset-sm-1 d-sm-flex d-block gap-2 pb-3 pt-2 handle-rtl-offset">
                            <div class="statuSub status-{{ item?.ticketOldStatus }} medium text-capitalize">{{ item?.ticketOldStatus | translate }}</div>
                            <span class="" *ngIf="!['REASSIGN', 'DELEGATE', 'REVOKE'].includes(item?.actionDescription)">
                                <i *ngIf="lang === 'en'" class="fa fa-arrow-right" aria-hidden="true"></i>
                                <i *ngIf="lang === 'ar'" class="fa fa-arrow-left" aria-hidden="true"></i>
                            </span>
                            <div *ngIf="!['REASSIGN', 'DELEGATE', 'REVOKE'].includes(item?.actionDescription)" class="statuSub status-{{ item?.ticketNewStatus }} medium text-capitalize">
                                {{ item?.ticketNewStatus | translate }}
                            </div>
                        </div>
                        <div
                            class="col-md-3 mt-2"
                            *ngIf="item?.reason && ['closed', 'close', 'rejected', 'reject', 'returned', 'return'].includes(item?.ticketNewStatus)"
                        >
                            <p class="text-danger" role="button" (click)="isShowReason = !isShowReason">
                                {{ 'reasons' | translate }} <span class="fw-bold">></span>
                            </p>
                        </div>
                        <div
                            class="col-md-12 mb-3"
                            *ngIf="isShowReason && ['closed', 'close', 'rejected', 'reject', 'returned', 'return'].includes(item?.ticketNewStatus)"
                        >
                            <textarea class="form-control w-100" readonly id="rejectionReason" rows="5" [(ngModel)]="item.reason!"></textarea>
                        </div>
                    </div>
                    <!-- End Sender Section -->
                </ng-container>
            </div>
        </div>
        <!-- End Stepper Section  -->
    </div>
</div>
<app-loader [fullLoader]="true" *ngIf="isLoading"></app-loader>
